import React from "react";
import { inject, observer } from "mobx-react";
import { UIStore, FilterStore } from "resource-centre-theme/src/stores";
import { Checkbox, P } from "resource-centre-theme/src/views/shared/components";
import { FilterModal } from "../../sections/TargetAudience/FilterModal";
import { tx } from "resource-centre-theme/src/libs/i18n";
import { Icons } from "resource-centre-theme/libs/assets";
import * as s from "./OptionColumn.module.scss";

interface Props {
  options: {
    value: string;
    slug: string;
    selected: boolean;
  }[];
  modalTitle: string;
  taxonomy?: string;
  uiStore?: UIStore;
  filterStore?: FilterStore;
}

export const OptionColumn = inject(
  "uiStore",
  "filterStore"
)(
  observer(({ uiStore, filterStore, options, modalTitle, taxonomy }: Props) => {
    const { isDesktop } = uiStore;
    const { toggleOption, overlayOpen, toggleOverlay } = filterStore;
    const filterDropdownClasses = [s.filterDropdown];
    const dropdownItemsClasses = [s.dropdownItems];
    let dropdownItemClasses = [s.dropdownItem];
    const maxSize = 5;

    return (
      <>
        <div className={filterDropdownClasses.join(" ")}>
          {isDesktop && (
            <>
              <h5 className={s.filterItemTitle}>{modalTitle}</h5>
              <div className={dropdownItemsClasses.join(" ")}>
                {options &&
                  options.slice(0, maxSize).map(item => {
                    return (
                      <div
                        className={dropdownItemClasses.join(" ")}
                        key={item.value}
                      >
                        <Checkbox
                          type="check"
                          onChange={() => toggleOption(options, item)}
                          selected={item.selected}
                        />
                        <div className={s.dropdownItemLabelContainer}>
                          <P className={s.dropdownItemLabel}>{item.value}</P>
                        </div>
                      </div>
                    );
                  })}
              </div>
              {options?.length > maxSize && (
                <>
                  <div
                    className={s.link}
                    onClick={() => toggleOverlay(taxonomy)}
                  >
                    {tx("misc.viewMore")}
                  </div>
                  <FilterModal
                    open={overlayOpen[taxonomy]}
                    onClose={() => toggleOverlay(taxonomy)}
                    title={modalTitle}
                    options={options}
                  />
                </>
              )}
            </>
          )}
          {!isDesktop && (
            <>
              <div
                className={s.filterItemTitleWrapper}
                onClick={() => toggleOverlay(taxonomy)}
              >
                <h5 className={s.filterItemTitle}>{modalTitle}</h5>
                <img
                  src={Icons.dropdown_small}
                  alt="dropdown-icon"
                  className={s.dropdownIcon}
                />
              </div>
              <FilterModal
                open={overlayOpen[taxonomy]}
                onClose={() => toggleOverlay(taxonomy)}
                title={modalTitle}
                options={options}
              />
            </>
          )}
        </div>
      </>
    );
  })
);
